import {RegisterClientCabinetRequestPayload} from '../shared/models/api/registerClientCabinetRequestPayload';

export enum DeliveryType {
  IssuePoint = 1,
  RussianPost = 2,
}

export interface RegisterCardApplicationRequestPayload extends RegisterClientCabinetRequestPayload {
  counterpartyDepartmentId: number;
  deliveryTypeId: DeliveryType;
  desiredAddress?: string;
}

export interface RegisterCardApplicationResponsePayload {
  counterpartyId: number;
  activationToken?: string | null;
}
